import { render, staticRenderFns } from "./UserCourseList.vue?vue&type=template&id=34aae790&"
import script from "./UserCourseList.vue?vue&type=script&lang=js&"
export * from "./UserCourseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports